import ConversationsClient from "./client/index.js";
export default ConversationsClient;
export var defaultClient = new ConversationsClient();